module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review"
  }, [_c('div', [_c('h2', [_vm._v("点评编辑")]), (_vm.detail && _vm.step === 1) ? _c('div', {
    staticClass: "form-box"
  }, [_c('div', {
    staticClass: "user-box"
  }, [_c('img', {
    attrs: {
      "src": (_vm.detail.HEADIMAGES && _vm.detail.HEADIMAGES.indexOf('http') === -1) ? _vm.$config.CONSTS.defaultAvatar : _vm.detail.HEADIMAGES
    }
  }), _c('div', {
    staticClass: "user-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.detail.REALNAME))]), _c('span', [_vm._v(_vm._s(_vm.detail.COMPANY))]), _c('span', [_vm._v(_vm._s(_vm.detail.OFFICE) + " 发布于 " + _vm._s(_vm.detail.lastoperationtime))])])]), _c('div', {
    staticClass: "form flex"
  }, [_c('el-form', {
    staticClass: "half",
    attrs: {
      "label-position": 'left'
    }
  }, [_c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "产品"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.PRODUCTNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "PRODUCTNAME", $$v)
      },
      expression: "detail.PRODUCTNAME"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "类别"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.CATEGORYNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "CATEGORYNAME", $$v)
      },
      expression: "detail.CATEGORYNAME"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "厂商简称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.FACTORYNAME),
      callback: function($$v) {
        _vm.$set(_vm.detail, "FACTORYNAME", $$v)
      },
      expression: "detail.FACTORYNAME"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "综合评分"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.ztgsnum),
      callback: function($$v) {
        _vm.$set(_vm.detail, "ztgsnum", $$v)
      },
      expression: "detail.ztgsnum"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "功能"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.FUNCTIONLEVEL),
      callback: function($$v) {
        _vm.$set(_vm.detail, "FUNCTIONLEVEL", $$v)
      },
      expression: "detail.FUNCTIONLEVEL"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "性能"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.PERFORMANCELEVEL),
      callback: function($$v) {
        _vm.$set(_vm.detail, "PERFORMANCELEVEL", $$v)
      },
      expression: "detail.PERFORMANCELEVEL"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "可扩展性"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.SCALABILITYLEVEL),
      callback: function($$v) {
        _vm.$set(_vm.detail, "SCALABILITYLEVEL", $$v)
      },
      expression: "detail.SCALABILITYLEVEL"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "易部署性"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.DEPLOYLEVEL),
      callback: function($$v) {
        _vm.$set(_vm.detail, "DEPLOYLEVEL", $$v)
      },
      expression: "detail.DEPLOYLEVEL"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "友好性"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.FRIENDLYLEVEL),
      callback: function($$v) {
        _vm.$set(_vm.detail, "FRIENDLYLEVEL", $$v)
      },
      expression: "detail.FRIENDLYLEVEL"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "提交时间"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.detail.lastoperationtime),
      callback: function($$v) {
        _vm.$set(_vm.detail, "lastoperationtime", $$v)
      },
      expression: "detail.lastoperationtime"
    }
  })], 1)], 1), _c('el-form', {
    staticClass: "half",
    attrs: {
      "label-position": 'left'
    }
  }, [_c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "优点"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "autosize",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.detail.advantages),
      callback: function($$v) {
        _vm.$set(_vm.detail, "advantages", $$v)
      },
      expression: "detail.advantages"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "不足之处"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "autosize",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.detail.disadvantages),
      callback: function($$v) {
        _vm.$set(_vm.detail, "disadvantages", $$v)
      },
      expression: "detail.disadvantages"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "建议提醒"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "autosize",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.detail.aftersales),
      callback: function($$v) {
        _vm.$set(_vm.detail, "aftersales", $$v)
      },
      expression: "detail.aftersales"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "点评价值"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": false
    },
    model: {
      value: (_vm.detail.editscoremark),
      callback: function($$v) {
        _vm.$set(_vm.detail, "editscoremark", $$v)
      },
      expression: "detail.editscoremark"
    }
  })], 1), _c('el-form-item', {
    staticClass: "flex",
    attrs: {
      "label": "点评状态"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.detail.isrecommendmark),
      callback: function($$v) {
        _vm.$set(_vm.detail, "isrecommendmark", $$v)
      },
      expression: "detail.isrecommendmark"
    }
  }, [_vm._v("有价值")]), _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.detail.isrecommendmark),
      callback: function($$v) {
        _vm.$set(_vm.detail, "isrecommendmark", $$v)
      },
      expression: "detail.isrecommendmark"
    }
  }, [_vm._v("无价值")]), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.detail.isrecommendmark),
      callback: function($$v) {
        _vm.$set(_vm.detail, "isrecommendmark", $$v)
      },
      expression: "detail.isrecommendmark"
    }
  }, [_vm._v("疑似厂商点评")])], 1)], 1)], 1), _c('div', {
    staticClass: "el-form-item bottom-ctrl"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpdate
    }
  }, [_vm._v("审核完毕")]), _c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")])], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-50b868e5!./~/_vue-loader@9.9.5@vue-loader/lib/template-loader.js?raw&engine=pug!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/posts/Edit.vue
// module id = 458
// module chunks = 11